import { trackEvent, TrackingType } from 'tracking/events'

export const TRACKING_NAMESPACE = 'homepage_reg'

// Page level events/actions

export enum RegAction {
  VALIDATION_ERROR = 'validation_error',
  LOGIN_CLICK = 'login_with_email_click',
}

const getSchema = () => 'reg_page_tracking'

interface RegActionOptions {
  action: RegAction
  trackingType?: TrackingType
  eventData?: Record<string, any>
}

export const trackSignupAction = ({
  trackingType = TrackingType.BATCHED,
  action,
  eventData,
}: RegActionOptions) =>
  trackEvent({
    type: trackingType,
    schema: getSchema(),
    payload: {
      event_name: `${TRACKING_NAMESPACE}.${action}`,
      form_name: 'direct_homepage_signup_modal',
      field_value: eventData.fieldValue,
    },
  })

interface EventData {
  fieldValue?: string
}

// Clicks

export const trackLoginLinkClick = (eventData: EventData) =>
  trackSignupAction({
    action: RegAction.LOGIN_CLICK,
    eventData: {
      fieldValue: eventData.fieldValue,
    },
  })

// Validation errors

export const trackValidationErrors = (eventData: EventData) =>
  trackSignupAction({
    action: RegAction.VALIDATION_ERROR,
    eventData: {
      fieldValue: eventData.fieldValue,
    },
  })
